export type Time = { hour: number; minute: number };
export type TimeRange = { start: Time; end: Time };

export function sortAndMergeTimeRanges(timeRanges: TimeRange[]): TimeRange[] {
  const rangesInMinutes = timeRanges
    .map((timeRange) => ({
      start: startToMinutes(timeRange.start),
      end: endToMinutes(timeRange.end),
    }))
    .sort((a, b) => a.start - b.start);

  const mergedRanges: Array<{ start: number; end: number }> = [];

  for (const range of rangesInMinutes) {
    if (range.end < range.start) {
      throw new Error("The end time of a time range must not be before its start time.");
    }
    const previousRange = mergedRanges.at(-1);
    if (!previousRange || range.start > previousRange.end) {
      mergedRanges.push({ ...range });
    } else {
      previousRange.end = Math.max(previousRange.end, range.end);
    }
  }

  return mergedRanges.map((range) => ({
    start: startFromMinutes(range.start),
    end: endFromMinutes(range.end),
  }));

  function startToMinutes(time: Time): number {
    return time.hour * 60 + time.minute;
  }

  function endToMinutes(time: Time): number {
    return time.hour === 0 && time.minute === 0 ? 24 * 60 : startToMinutes(time);
  }

  function startFromMinutes(minutes: number): Time {
    return { hour: Math.floor(minutes / 60), minute: minutes % 60 };
  }

  function endFromMinutes(minutes: number): Time {
    return minutes === 24 * 60 ? { hour: 0, minute: 0 } : startFromMinutes(minutes);
  }
}
